import Search from "./Search";

const CancelPurchase = () => {
  return (
    <>
      <div className="page-header">
        <div className="page-title">
          <h2>Alışveriş İptal</h2>
        </div>
      </div>
      <div className="page-content">
        <Search />
      </div>
    </>
  );
};
export default CancelPurchase;
